import GetShopArticleTaxHistoryByShopArticleTaxIdRequestModelBase from '../_generated/modelBases/get-shop-article-tax-history-by-shop-article-tax-id-request-model-base';

export default class GetShopArticleTaxHistoryByShopArticleTaxIdRequestModel extends GetShopArticleTaxHistoryByShopArticleTaxIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
